const DEFAULT_DEDUCTIBLE = [
  {
    key: 1,
    lable: 'Per Occurrence Deductible',
    text: '$2,500',
  },
];
const DEFAULT_DEDUCTIBLE_NY_NON_STATECODE = [
  {
    key: 1,
    lable: 'Per Occurrence Deductible',
    text: '$10,000',
  },
];
const DEFAULT_DEDUCTIBLE_NY = [
  {
    key: 1,
    lable: 'Per Occurrence Deductible: Related to construction project work',
    text: '$10,000',
  },
  {
    key: 2,
    lable: 'Per Occurrence Deductible: Not related to construction project work',
    text: '$25,000',
  },
];
const DEFAULT_DEDUCTIBLE_DEMOCOST = [
  {
    key: 1,
    lable: 'Per Occurrence Deductible',
    text: '$25000',
  },
];

export const getDeductible = (isNYDeductible, projectState, demoCost, isDemolitionDetailsInterior, contractor) => {
  if (demoCost > 2000000 || isDemolitionDetailsInterior === 'false' || contractor === 'false') {
    return DEFAULT_DEDUCTIBLE_DEMOCOST;
  }
  if (projectState === 'New York') {
    if (isNYDeductible) {
      return DEFAULT_DEDUCTIBLE_NY;
    }
    return DEFAULT_DEDUCTIBLE_NY_NON_STATECODE;
  }
  return DEFAULT_DEDUCTIBLE;
};
